import { useEffect } from 'react';
import { useAppVersionState } from '@/shared/utils/appVersionStore';
import { useSharedUiText } from '@/shared/ui/sharedUiText';

function preventAccidentalUnload(event: BeforeUnloadEvent): void {
    event.preventDefault();
    // 部分瀏覽器要設定 returnValue 才會跳出原生的「離開網站？」確認
    event.returnValue = '';
}

/**
 * 有新版本時才掛上離開確認：使用者按「重新整理」或手動重整時，
 * 若欄位裡有尚未儲存的輸入，由瀏覽器原生對話框擋一下。
 */
function useUnloadGuard(isActive: boolean): void {
    useEffect(() => {
        if (!isActive) return undefined;
        window.addEventListener('beforeunload', preventAccidentalUnload);
        return () => window.removeEventListener('beforeunload', preventAccidentalUnload);
    }, [isActive]);
}

/** 常駐、不阻擋操作的提示；永遠不自動重新整理 */
export function NewVersionBanner() {
    const t = useSharedUiText();
    const { isStale, hasUnsavedTyping } = useAppVersionState();
    useUnloadGuard(isStale && hasUnsavedTyping);

    if (!isStale) return null;

    return (
        <div
            role="status"
            className="flex flex-wrap items-center justify-center gap-3 border-b border-warning/60 bg-warning/15 px-4 py-1.5 text-sm"
        >
            <span>{t('staleApp.bannerMessage')}</span>
            <button
                type="button"
                className="btn btn-xs btn-warning"
                onClick={() => window.location.reload()}
            >
                {t('refresh')}
            </button>
        </div>
    );
}
